import * as actionTypes from "./actionTypes";
import { EmperorTentState } from "../reducers/stateType";
import { GovernyInfo } from "../../lib/types";

export const initEmperorTentState = (newState?: EmperorTentState) => ({
  type: actionTypes.EMP_TENT_INIT_STATE,
  newState
});

export const setChanged = (changed: boolean) => ({
  type: actionTypes.EMP_TENT_SET_CHANGED,
  changed
})

export const updateMember = (memberId: number, update: Partial<GovernyInfo>) => ({
  type: actionTypes.EMP_TENT_UPDATE_MEMBER,
  memberId,
  update
});
